import React, { useEffect, useState } from 'react';
import useForm from '@utils/useForm';
import { Helpers } from '@utils/helpers';
import { GAAviva } from '@utils/gaAviva';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { useAvivaSelector, useAvivaDispatch } from '@redux/hook';
import { useHistory } from 'react-router-dom';
import { isEmpty, get } from 'lodash';
import { setLoadingState } from '@redux/slices/loadingSlice'
import { ContactForm } from '@models/SIO/Contact.model';
import { postContact } from '@api/index';

import { LeftGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import RadioButtonGroup from '@components/RadioButtonGroup';
import RadioButton from '@components/RadioButton';
import Heading from '@components/Heading';
import Dropdown from '@components/Dropdown';
import Input from '@components/Input';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Button from '@components/Button';
import Bullet from '@components/Bullet';
import Segment from '@components/Segment';
import Link from '@components/Link';
import { validate } from './service';

const page = 'Contact';

const fluidBox = css`
  margin-top: -40px!important;
`;

const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form, acquisition } = GA.digitalData;
  form.name = 'Contact';
  GA.trackPageLoad({ form, acquisition });
}

const trackFormSubmmit = (error: string = ''): void => {
  const GA = GAAviva.getInstance();
  if (isEmpty(error)) {
    GA.trackFormSuccess({});
    return;
  }
  const { form } = GA.digitalData;
  form.error.messages = error;
  GA.trackFormFailed({ form });
}
export interface ContactProps { }

const createContactRequest = (form: ContactForm, isVulnerable: boolean | undefined, transactionId: number, isRental: boolean | undefined) => {
  const content = {
    email: form.emailId,
    fname: form.surname,
    lname: form.givname,
    title: Helpers.getSalutationByCode(form.salutation || ''),
    dateOfBirth: form.dob,
    phone_number: form.mobileNum && `+65${form.mobileNum}`,
    pdpaDetails: "{}",
    selectedPlan: 'Singlife Simple Term',
    VulnerableCustomer: isVulnerable ? 'true' : 'false',
    RentalPostalCustomer: isRental ? 'true' : 'false',
    referrerDetails: `${window.location.origin}/api/contactUs`
  }
  return {
    transactionId,
    content: JSON.stringify(content)
  }
}

function Contact(props: ContactProps) {
  console.log(`Aviva - ${page}`);
  const history = useHistory();
  const website = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
  const dispatch = useAvivaDispatch(); const theme: ITheme = useTheme();
  const salutations = useAvivaSelector(state => state.staticData.salutations);
  const basicDetails = useAvivaSelector(state => state.sioStep1.basicDetails);
  const myInfoForm = useAvivaSelector(state => state.sioStep2.myInfoForm);
  const retrievedMyInfo = useAvivaSelector(state => state.sioStep2.retrievedMyInfo);
  const hasMyInfo = useAvivaSelector(state => state.sioStep2.hasMyInfo);
  const [isVulnerable, setIsVulnerable] = useState<boolean | undefined>(undefined);
  const [isRental, setIsRental] = useState<boolean | undefined>(undefined);
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const [isSubmited, setIsSubmitted] = useState<boolean>(false);

  const urlParams = Helpers.getURLSearchParams();

  const onBack = () => {
    history.goBack();
  }

  const { values, errors, patchValue, handleChange, formValid } = useForm(new ContactForm(myInfoForm), () => { }, validate);

  const getTimestamp = () => {
    const pad = (i: string | number) => { return (i < 10) ? '0' + i : i; };

    const d = new Date();
    const Y = d.getFullYear();
    const m = d.getMonth() + 1;
    const D = d.getDate();
    const H = d.getHours();
    const M = d.getMinutes();
    const S = d.getSeconds();
    const ms = ('00' + d.getMilliseconds()).slice(-3);
    return `` + Y + pad(m) + pad(D) + pad(H) + pad(M) + pad(S) + ms;
  }

  const onSubmit = async () => {
    dispatch(setLoadingState(true));
    let transactionId = retrievedMyInfo?.id || Number(getTimestamp());
    console.log({ transactionId });
    const payload: any = createContactRequest(values, isVulnerable, transactionId, isRental);
    console.log({ payload });
    try {
      const response = await postContact(payload);
      console.debug(response);
      setIsSubmitted(true);
      trackFormSubmmit();
      Helpers.clearCached();
      dispatch(setLoadingState(false));

    } catch (error) {
      trackFormSubmmit(get(error, 'message'));
      console.error(error);
      dispatch(setLoadingState(false));
    }
  }

  useEffect(() => {
    if (!isPageLoaded) {
      trackOnload();
      if (basicDetails) {
        patchValue({
          dob: Helpers.parseDobString(basicDetails.dob)
        })
      }
      if (isVulnerable === undefined) {
        const vulnerable = urlParams.get('ulnerable');
        setIsVulnerable(vulnerable === 'true');
      }
      if (isRental === undefined) {
        const rental = urlParams.get('rental');
        setIsRental(rental === 'true');
      }
      setIsPageLoaded(true);
    }
  }, [hasMyInfo, patchValue, isPageLoaded, urlParams, basicDetails, isRental, isVulnerable]);
  console.log(values);

  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 20px" paddingTablet="80px 0 80px 30px">
        <ContainerGrid>
          <LeftGrid>
            {!isSubmited ? (
              <React.Fragment>
                <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for your interest in this plan. </Heading>
                {retrievedMyInfo ? (
                  <Heading variant="label" color={theme.colors.white} margin="0 0 10px" fontWeight={300}>
                    We are unable to proceed with your application at the moment. Please fill up the below form and we’ll appoint a financial adviser representative to contact you. The representative will conduct financial needs analysis and recommend suitable products to meet your insurance needs.
                  </Heading>
                ) : (
                  <Heading variant="label" color={theme.colors.white} margin="0 0 10px" fontWeight={300}>We are unable to proceed with your application at the moment. Please fill up the below form and we’ll appoint a financial adviser representative to contact you. The representative will conduct financial needs analysis and recommend suitable products to meet your insurance needs.</Heading>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for your submission. </Heading>
                  <Heading variant="label" color={theme.colors.white} fontWeight={300}>Our financial adviser representative will be in touch with you shortly. Please visit our <Link color={theme.colors.white} fontSize={theme.fontSize.label} fontSizeTablet={theme.fontSize.label} target="_blank" rel="noopener noreferrer" url={website} text="website"></Link> for other insurance solutions.</Heading>
                  <style>
                    {`footer {
                      position: fixed;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    }`}
                  </style>
              </React.Fragment>
            )}

          </LeftGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        {!isSubmited && (<LeftGrid>
          <Heading variant="label">Salutation</Heading>
          <Dropdown source={Helpers.filterSalutations(basicDetails?.gender || '', salutations, '')} bindId="code" bindLabel="description" name="salutation" value={values['salutation']} onChange={handleChange} placeholder="Please select" />
          <Heading variant="label">Given name</Heading>
          {!errors?.givname?.isValid && errors?.givname?.message && (<Bullet variant="error">{errors?.givname?.message}</Bullet>)}
          <Input name="givname" value={values['givname']} invalid={!isEmpty(errors?.givname?.message)} type="alphanumeric" maxLength={40} onChange={handleChange} />
          <Heading variant="label" >Family name</Heading>
          {!errors?.surname?.isValid && errors?.surname?.message && (<Bullet variant="error">{errors?.surname?.message}</Bullet>)}
          <Input name="surname" value={values['surname']} invalid={!isEmpty(errors?.surname?.message)} type="alphanumeric" maxLength={40} onChange={handleChange} />
          <Heading variant="label">Mobile number</Heading>
          {!errors?.mobileNum?.isValid && errors?.mobileNum?.message && (<Bullet variant="error">{errors?.mobileNum?.message}</Bullet>)}
          <Input type="numeric" variant="prefix" boxLabel="+65" invalid={!isEmpty(errors?.mobileNum?.message)} maxLength={8} name="mobileNum" value={values['mobileNum']} onChange={handleChange} />
          <Heading variant="label">Email address</Heading>
          {!errors?.emailId?.isValid && errors?.emailId?.message && (<Bullet variant="error">{errors?.emailId?.message}</Bullet>)}
          <Input name="emailId" value={values['emailId']} invalid={!isEmpty(errors?.emailId?.message)} maxLength={50} onChange={handleChange} />
          {!hasMyInfo && (
            <><Heading variant="label">Are you an existing Singlife customer?</Heading>
              <RadioButtonGroup value={values['isAvivaCustomer']} name="isAvivaCustomer" onChange={handleChange} margin={`0 0 ${values['isAvivaCustomer'] === 'Y' ? '15px' : '40px'}`}>
                <RadioButton value="Y" text="Yes"></RadioButton>
                <RadioButton value="N" text="No"></RadioButton>
              </RadioButtonGroup></>
          )}
          {values['isAvivaCustomer'] === 'Y' && (
            <Segment hasBorderTop={true}>
              <Heading margin="0 0 15px" variant="label">NRIC (last 4 characters e.g. 123A)</Heading>
              {!errors?.nric?.isValid && errors?.ninricrc?.message && (<Bullet variant="error">{errors?.nric?.message}</Bullet>)}
              <Input name="nric" value={values['nric']} maxLength={4} invalid={!isEmpty(errors?.nric?.message)} onChange={handleChange} margin={0} />
            </Segment>
          )}
          <ContainerBlock padding={20} paddingTablet={20} margin="40px 0 40px 0" background={theme.colors.grey[600]}>
            <Text>By clicking “Submit”, you consent to Singapore Life Ltd. (“Singlife”) and Singlife related group of companies contacting you to provide you with information concerning Singlife and Singlife related group of companies’ products and services. You also consent to Singlife using, disclosing or transferring your personal data in this form to Singlife related group of companies, third party providers or intermediaries, whether located in Singapore or elsewhere, for the above purposes and for research, audit, regulatory and compliance purposes.</Text>
          </ContainerBlock>
          <Button label="Submit" disabled={!formValid || (!hasMyInfo && values['isAvivaCustomer'] === undefined)} margin="0 0 20px" onClick={onSubmit} />
          <Button variant="secondary" label="Back" margin="0 0 40px" onClick={onBack} />
        </LeftGrid>)}
      </ContainerGrid>

    </Container>
  );
};

export default Contact;
